import { Box } from '@mui/material';
import React from 'react';

/** Right-hand messages chrome when no conversation is selected or loaded yet. */
const NoChannelPane = () => (
  <Box
    data-testid="messages-no-channel"
    sx={{
      flexGrow: 1,
      minWidth: 0,
      display: 'flex',
      bgcolor: 'background.paper',
    }}
  />
);

export default NoChannelPane;
